import ProfilePicture from "@/components/common/profile-picture";
import VerifiedBadgeCheck from "@/components/common/verified-badge-check";
import { TCommunityInfo } from "@/types/community";
import Link from "next/link";

const HeroSectionModerators = ({ moderators }: { moderators: TCommunityInfo["moderators"] }) => {
	if (!moderators?.length) {
		return null;
	}

	return (
		<>
			<h3 className="mb-1.5 text-xs font-medium text-gray-600 3xl:text-sm">Moderated by</h3>

			<div className="flex gap-2 max-md:flex-wrap md:flex-wrap">
				{moderators.map((moderator, index) => (
					<Link
						key={index}
						target="_blank"
						href={moderator.username ? `/user/${moderator.username}` : "#"}
						className="flex items-center gap-2 rounded-lg bg-white p-3 shadow-sm"
					>
						<ProfilePicture
							profilePictureUrl={moderator.image}
							className={{
								image: "h-8 w-8 rounded-full",
								container: "h-10 w-10",
								badgeImage: "-bottom-4 h-8 w-8",
							}}
							isVerified={moderator.isVerified}
							isFounder={moderator.isFounder}
						/>

						<div className="flex flex-col">
							<div className="flex items-center justify-start gap-px">
								<p className="text-sm font-semibold text-gray-700">{moderator.name}</p>
								<VerifiedBadgeCheck iconClassName="w-4 h-4" />
							</div>

							<p className="text-xs text-gray-500">
								{moderator.jobTitle} | {moderator.company}
							</p>
						</div>
					</Link>
				))}
			</div>
		</>
	);
};

export default HeroSectionModerators;
